import { Typography } from "@mui/material";
import { useState } from "react";

function TruncateText({ text, maxLength }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  const textStyle = {
    cursor: text.length > maxLength ? "pointer" : "auto",
    maxWidth: "40vw",
    wordWrap: "break-word",
  };

  return (
    <div style={textStyle} onClick={toggleExpansion}>
      <Typography variant="subtitle1">
        {expanded
          ? text
          : text.slice(0, maxLength) + (text.length > maxLength ? "..." : "")}
      </Typography>
    </div>
  );
}

export default TruncateText;
